import { render, staticRenderFns } from "./peaAuthorizationPreview.vue?vue&type=template&id=03534984&scoped=true"
import script from "./peaAuthorizationPreview.vue?vue&type=script&lang=js"
export * from "./peaAuthorizationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03534984",
  null
  
)

export default component.exports